<template>
  <div class='SubLinkNave' @click="push">
    <component v-if="hasIcon" :is="data.icon" tam="18px" color="currentColor" :count="false" class="icon"/>
    {{ data.name }}
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { icons } from '@/components/icons'
export default {
  name: 'SubLinkNave',
  components: { ...icons },
  props: ['data'],
  computed: {
    // só exibe se o usuário escolheu um ícone para a categoria
    hasIcon () {
      return !!this.data.icon && !!icons[this.data.icon]
    }
  },
  methods: {
    ...mapActions(['changeFilterProdStore', 'GetStoreProducts', 'Loading']),
    async push () {
      this.Loading(true)
      this.$router.push(`/loja/${this.data.link}`)
      this.changeFilterProdStore({ categoria: this.data.link })
        .then(() => {
          this.GetStoreProducts({ params: { last: [], limit: 8, categoria: this.data.link }, init: true })
            .then(() => this.Loading(false))
        })
    }
  }
}
</script>

<style scoped>
.SubLinkNave {
  display: flex;
  align-items: center;
  text-align: left;
  padding: 5%;
  cursor: pointer;
  color: #000000;
}

.icon {
  display: flex;
  margin-right: 8px;
}

.SubLinkNave:hover {
  background-color: #CCCCCC;
}
</style>
